const Button = ({ title, style, onClick, disable }) => {
  return (
    <button
      onClick={onClick}
      disabled={disable}
      className={
        "w-full md:w-fit p-2 h-12 rounded-full font-bold  flex items-center justify-center " +
        style
      }
    >
      <div className=" truncate text-center px-9">{title}</div>
    </button>
  );
};
export default Button;
